import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import WelcomeSvg from './hired.svg';
import './ProjectBegunPopup.css';

export const ProjectBegunPopup = ({
  handleClose,
  project_name: projectName,
  category,
}) => (
  <div className="project-begun">
    <div className="project-begun__image-container">
      <img
        alt="welcome"
        className="project-begun__image-container__image"
        src={WelcomeSvg}
      />
    </div>
    <div className="project-begun__body">
      <div className="project-begun__body__title">
        Congrats! Your project has begun.
      </div>
      <div className="project-begun__body__description">
        <h3>{projectName}</h3>
        <h3>Category: {category}</h3>
        <br />
        Check your dashboard to see project updated including milestones,
        deadlines, and more.
      </div>
    </div>
    <div className="project-begun__action">
      <Button
        onClick={handleClose}
        className="project-begun__action--continue"
        rounded
        title="LET'S GO"
      />
    </div>
  </div>
);

ProjectBegunPopup.propTypes = {
  handleClose: PropTypes.func,
  project_name: PropTypes.string,
  category: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Popup/ProjectBegunPopup/ProjectBegunPopup.js